import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
                <Icon name="Waves" size={24} color="white" />
              </div>
              <span className="text-2xl font-bold text-white">PaddleTurkiye</span>
            </div>
            <p className="text-gray-400 mb-2">
              Türkiye'nin en kapsamlı kürek sörfü platformu. Suya özgürlük.
            </p>
            <p className="text-xs text-cyan-500 font-medium">Bir Sıfır Noktası markasıdır.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/event-discovery" className="hover:text-cyan-400 transition-colors">
                  Etkinlikler
                </Link>
              </li>
              <li>
                <Link to="/spot-guide" className="hover:text-cyan-400 transition-colors">
                  Spot Rehberi
                </Link>
              </li>
              <li>
                <Link to="/official-store" className="hover:text-cyan-400 transition-colors">
                  Mağaza
                </Link>
              </li>
              <li>
                <Link to="/user-marketplace" className="hover:text-cyan-400 transition-colors">
                  İkinci El
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="hover:text-cyan-400 transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="hover:text-cyan-400 transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">İletişim</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Icon name="Building2" size={16} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">
                  <span className="text-white font-medium">Sıfır Noktası</span><br />
                  Serhat ÇOKUÇKUN
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="MapPin" size={16} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">
                  Adalet Mah. Manas Blv. No: 47 B<br />
                  (Folkart Towers) İç Kapı No: 2601<br />
                  Bayraklı / İZMİR
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Phone" size={16} className="text-cyan-400 flex-shrink-0" />
                <a href="tel:+905415423535" className="text-gray-400 hover:text-cyan-400 transition-colors">
                  +90 541 542 35 35
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Mail" size={16} className="text-cyan-400 flex-shrink-0" />
                <a href="mailto:info@paddleturkiye.com" className="text-gray-400 hover:text-cyan-400 transition-colors">
                  info@paddleturkiye.com
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Bizi Takip Edin</h3>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61584920242293"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-500 hover:to-cyan-500 transition-all duration-300"
                aria-label="Facebook"
              >
                <Icon name="Facebook" size={20} />
              </a>
              <a
                href="https://www.instagram.com/paddleturkiye/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-500 hover:to-cyan-500 transition-all duration-300"
                aria-label="Instagram"
              >
                <Icon name="Instagram" size={20} />
              </a>
              <a
                href="https://www.youtube.com/@paddleturkiye"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-500 hover:to-cyan-500 transition-all duration-300"
                aria-label="YouTube"
              >
                <Icon name="Youtube" size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Legal Links + Copyright */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4 text-sm">
            <Link to="/mesafeli-satis-sozlesmesi" className="text-gray-500 hover:text-cyan-400 transition-colors">
              Mesafeli Satış Sözleşmesi
            </Link>
            <Link to="/iptal-iade-kosullari" className="text-gray-500 hover:text-cyan-400 transition-colors">
              İptal ve İade Koşulları
            </Link>
            <Link to="/teslimat-politikasi" className="text-gray-500 hover:text-cyan-400 transition-colors">
              Teslimat Politikası
            </Link>
            <Link to="/kvkk-gizlilik-politikasi" className="text-gray-500 hover:text-cyan-400 transition-colors">
              KVKK ve Gizlilik Politikası
            </Link>
          </div>

          <p className="text-center text-gray-500 text-sm">
            © {new Date()?.getFullYear()} PaddleTurkiye — Sıfır Noktası'na ait tescilli bir markadır. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;